export default (store) => {
    const userStore = store.ng.injector.get('Users'),
        pusher = userStore.dispatch('getPusher');

    _.each(store.state.activePusherListeners, (activeListener) => {
        pusher.unbind(activeListener.event, activeListener.callback);
    });
}



// WEBPACK FOOTER //
// ./src/app/store/base/actions/unregister-pusher-listeners.js